import React from 'react';
import PropTypes from 'prop-types';
import {withFormsy, propTypes} from "formsy-react";
import {FormGroup, InputGroup, Input} from 'reactstrap';
import IconSvg from "../IconSvg";

const FormsyInput = withFormsy(class extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        ...propTypes,
    };

    constructor(props) {
        super(props);

        this.changeValue = this.changeValue.bind(this);
    }

    changeValue(event) {
        const value = event.target.value;
        this.props.setValue(value);
    }

    render() {
        const {name, id, getValue, className, placeholder} = this.props;


        return (<Input className={className} name={name} placeholder={placeholder} id={id} type="text" value={getValue()} onChange={this.changeValue} />)
    }
});

export class DualInputFormGroup extends React.Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        values: PropTypes.array.isRequired,
        inputProps: PropTypes.shape({
            key: PropTypes.object,
            value: PropTypes.object,
        }),
        onRemove: PropTypes.func,
    };

    render() {
        const {name, values, onRemove, inputProps} = this.props;

        const keyProps = inputProps && inputProps.key;
        const valueProps = inputProps && inputProps.value;

        return (
            <FormGroup>
                <InputGroup>
                    <FormsyInput className="input-group-key" {...keyProps} name={name + "-key"} value={values[0]}/>
                    <div className="input-group-append input-group-prepend">
                        <span className="input-group-text">:</span>
                    </div>
                    <FormsyInput className="input-group-value" {...valueProps} name={name + "-value"} value={values[1]}/>
                    {onRemove &&
                    <div className="input-group-append">
                        <span className="input-group-text">
                            <a onClick={onRemove} className="input-group-remove">
                                <IconSvg id='remove'/>
                            </a>
                        </span>
                    </div>
                    }
                </InputGroup>
            </FormGroup>
        )
    }
}

export default DualInputFormGroup;


// WEBPACK FOOTER //
// ./src/components/Form/DualInputFormGroup.jsx